<template>
  <div>
    <surveys-table
      surveyName="DLQI"
      surveyCode="DLQI"
      :permission="{
        createSurvey: permissions.CREATE_SURVEY_DLQI,
        viewDetail: permissions.SEE_DETAIL_SURVEY_DLQI,
      }"
    ></surveys-table>
  </div>
</template>

<script>
import SurveysTable from "../../../components/Forms/SurveysTable.vue";
import { permissions } from "../../../enum/applicationPermissions";

export default {
  components: {
    SurveysTable,
  },
  data() {
    return {
      permissions: permissions,
    };
  },
};
</script>

<style scoped></style>
